import React, {FC, PropsWithChildren, useEffect, useRef, useState} from 'react';
import {AvailableStatusesContext} from './AvailableStatusesContext';
import {Option, useSearch} from '../../../../hooks/dropdown/useSearch';
import {STATUS_FIELD} from '../../constants';
import {Form} from '../../../../stores/Form';

export type AvailableStatusesWrapperProps = {
    form: Form;
    records: any[];
};

export const AvailableStatusesWrapper: FC<PropsWithChildren<AvailableStatusesWrapperProps>> = ({
    children,
    form,
    records
}) => {
    const [statuses, setStatuses] = useState<Option[]>([]);
    const statusesFetchedFromAnEmptRow = useRef(false);
    const statusesFetchedFromNonEmptyRow = useRef(false);

    const [{results: availableStatuses}, searchHandlers] = useSearch(
        form?.getColumnByName(STATUS_FIELD) || undefined
    );

    useEffect(() => {
        const fetchStatuses = async () => {
            if (records && records.length !== 0 && availableStatuses.length === 0) {
                if (!statusesFetchedFromAnEmptRow.current) {
                    //try to fetch statuses from an empty row first
                    statusesFetchedFromAnEmptRow.current = true;
                    searchHandlers.handleSearchOpen();
                } else if (!statusesFetchedFromNonEmptyRow.current) {
                    //it's fallback - fetch statuses with a dummy query
                    //generally this should not happen
                    statusesFetchedFromNonEmptyRow.current = true;
                    searchHandlers.handleSearchOpen('.');
                }
            }
        };
        fetchStatuses();
    }, [records, availableStatuses]);

    useEffect(() => {
        setStatuses(availableStatuses);
    }, [availableStatuses]);

    return (
        <AvailableStatusesContext.Provider value={{statuses, setStatuses}}>
            {children}
        </AvailableStatusesContext.Provider>
    );
};
